export default "__VITE_ASSET__6bcd238e__"